import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import moment from 'moment';
import 'vdp-used/components/WarrantiesAndPolicies/WarrantiesAndPolicies.scss';

const WarrantySupplementary = ({ supplementary }) => {
    if (!supplementary.date && !supplementary.km) {
        return null;
    }
    moment.locale(LocaleService.getLocale());

    const expirationDate =
        supplementary.date && supplementary.date > 0 ? (
            <p className="vdp-information__secondary-text vdp-supplementary__date">
                <span className="is-light">{LocaleService.t('VDP_USED.WARRANTY.EXPIRATION_DATE')}</span>
                {moment(supplementary.date).format('LL')}
            </p>
        ) : null;
    const supKm =
        supplementary.km && supplementary.km > 0 ? (
            <p className="vdp-information__secondary-text vdp-supplementary__km">
                <span className="is-light">{LocaleService.t('VDP_USED.WARRANTY.MAX_DISTANCE')}</span>
                {LocaleService.t('VDP_USED.WARRANTY.DISTANCE', { distance: supplementary.km })}
            </p>
        ) : null;

    return (
        <div className="vdp-information__warranty-wrapper">
            <p className="vdp-information__subtitle sr-text is-bold">
                {LocaleService.t('VDP_USED.WARRANTY.SUPPLEMENTARY')}
            </p>
            {expirationDate}
            {supKm}
        </div>
    );
};

WarrantySupplementary.defaultProps = {
    supplementary: {
        date: 0,
        km: 0,
    },
};

WarrantySupplementary.propTypes = {
    supplementary: PropTypes.shape({
        date: PropTypes.number,
        km: PropTypes.number,
    }),
};

WarrantySupplementary.displayName = 'WarrantySupplementary';

export default WarrantySupplementary;
